const footerLinks = [
  { label: 'Documentary', href: '#documentary' },
  { label: 'Thesis Preview', href: '#thesis' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="bg-[#1B4332] text-[#F8F5F0]">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3
              className="text-2xl font-bold text-[#F8F5F0] mb-3"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Echoes of the Ganga
            </h3>
            <p className="text-[#F8F5F0]/65 text-sm leading-relaxed mb-5">
              A data-driven environmental initiative uncovering pollution patterns in the Ganga River through data science and documentary storytelling.
            </p>
            <div className="flex items-center gap-2 text-[#2A9D8F] text-sm">
              <i className="ri-map-pin-line" />
              <span>Pune, India | Field Study: Rishikesh, Haridwar, IIT Roorkee</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#F8F5F0] font-semibold text-sm uppercase tracking-wider mb-5">Explore</h4>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                  className="text-[#F8F5F0]/60 hover:text-[#F4A261] text-sm transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Project info */}
          <div>
            <h4 className="text-[#F8F5F0] font-semibold text-sm uppercase tracking-wider mb-5">Project</h4>
            <div className="flex flex-col gap-3 text-[#F8F5F0]/60 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line text-[#2A9D8F]" />
                <span>Data: 2000 – 2024</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-database-line text-[#2A9D8F]" />
                <span>15+ Official Data Sources</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-2-line text-[#2A9D8F]" />
                <span>Gangotri to West Bengal</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-film-line text-[#2A9D8F]" />
                <span>Documentary — Part 1 Live</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#F8F5F0]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#F8F5F0]/45 text-xs">
            &copy; {new Date().getFullYear()} Echoes of the Ganga. All rights reserved.
          </p>
          <p className="text-[#F4A261]/70 text-xs">
            Built by Sarthak Bobade &amp; Pavan Khandare
          </p>
        </div>
      </div>
    </footer>
  );
}
